var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationUpdateApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Direct apply Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2F3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BE2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.8502269,33.8181818 C17.221886,33.8181818 18.4704992,33.586947 19.5960666,33.1244774 C20.7216339,32.6620079 21.6838124,32.0170962 22.4826021,31.1897423 C23.2813918,30.3623885 23.9006556,29.3822924 24.3403933,28.249454 C24.7801311,27.1166157 25,25.8798278 25,24.5390903 C25,23.2068385 24.7801311,21.9742934 24.3403933,20.841455 C23.9006556,19.7086167 23.2813918,18.730642 22.4826021,17.907531 C21.6838124,17.08442 20.7216339,16.4395083 19.5960666,15.9727959 C18.4704992,15.5060835 17.221886,15.2727273 15.8502269,15.2727273 L15.8502269,15.2727273 L9,15.2727273 L9,33.8181818 L15.8502269,33.8181818 Z M15.8502269,30.5087665 L13.1149773,30.5087665 L13.1149773,18.5821426 L15.8502269,18.5821426 C16.6328795,18.5821426 17.3308119,18.7200349 17.9440242,18.9958196 C18.5572365,19.2716042 19.075643,19.6661883 19.4992436,20.179572 C19.9228442,20.6929556 20.2476046,21.3187746 20.473525,22.0570288 C20.6994453,22.795283 20.8124054,23.6226368 20.8124054,24.5390903 C20.8124054,25.4640295 20.6994453,26.2956261 20.473525,27.0338803 C20.2476046,27.7721345 19.9228442,28.3979535 19.4992436,28.9113371 C19.075643,29.4247208 18.5572365,29.8193049 17.9440242,30.0950895 C17.3308119,30.3708741 16.6328795,30.5087665 15.8502269,30.5087665 L15.8502269,30.5087665 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-37.5%",
    y: "-32.4%",
    width: "175.0%",
    height: "164.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.482352941   0 0 0 0 0.88627451  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01_Notification_Universities-_specfications",
    transform: "translate(-930.000000, -550.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Direct-apply-Copy",
    transform: "translate(930.000000, 550.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1126187,15.2727273 L39,33.8181818 L35.8005427,33.8181818 L35.6272049,33.8109336 C35.3479195,33.786773 35.1166893,33.7022109 34.9335142,33.5572471 C34.7137042,33.3832907 34.5468114,33.1605416 34.4328358,32.8889998 L34.4328358,32.8889998 L33.3826323,29.6559556 L26.6173677,29.6559556 L25.5671642,32.8889998 L25.5048847,33.028759 C25.4104478,33.2113708 25.2704206,33.3790479 25.0848033,33.5317901 C24.8527815,33.7227179 24.5658073,33.8181818 24.2238806,33.8181818 L24.2238806,33.8181818 L21,33.8181818 L27.8873813,15.2727273 L32.1126187,15.2727273 Z M29.9877883,19.0912835 C29.8656716,19.60891 29.7354138,20.0883509 29.5970149,20.5296063 C29.458616,20.9708617 29.3283582,21.3527173 29.2062415,21.6751731 L29.2062415,21.6751731 L27.5698779,26.7283958 L32.4423338,26.7283958 L30.7937585,21.6497161 L30.7195115,21.4493692 C30.619213,21.1730754 30.5137042,20.8601235 30.4029851,20.5105135 C30.2645862,20.073501 30.1261872,19.6004243 29.9877883,19.0912835 Z",
    id: "Combined-Shape",
    fill: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "DA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationUpdateApplication);
export default __webpack_public_path__ + "static/media/application_update_application.a480e76fd2d9c4064d5dd5a6ab625d62.svg";
export { ForwardRef as ReactComponent };